module.exports = __webpack_public_path__ + "static/media/bi_mascot_vic_m.5b336da7.png";